if (!customElements.get('doma-approved-menu')) {
  customElements.define('doma-approved-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.timers = new Set();
      const listen = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal: this.abort.signal });
      if (this.dataset.mode === 'mobile') {
        const drawer = this.closest('header-drawer');
        const mainDetails = drawer.querySelector('#Details-menu-drawer-container');
        this.querySelectorAll('.doma-mobile-accordion').forEach(details => {
          listen(details, 'toggle', () => {
            details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
            if (mainDetails.open && mainDetails.classList.contains('menu-opening') && mainDetails.contains(document.activeElement) && typeof trapFocus === 'function') {
              trapFocus(mainDetails, document.activeElement);
            }
          });
        });
        listen(this.querySelector('[data-doma-close-drawer]'), 'click', event => {
          const summary = mainDetails.querySelector('summary');
          drawer.closeMenuDrawer(event, summary);
          summary.setAttribute('aria-expanded', 'false');
        });
        return;
      }
      this.details = [...this.querySelectorAll('.doma-nav-details')];
      this.hoverQuery = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      const cancel = details => {
        clearTimeout(details.openTimer);
        clearTimeout(details.closeTimer);
      };
      const close = (details, focus = false) => {
        cancel(details);
        details.open = false;
        details.openedByHover = false;
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) details.querySelector('summary').focus();
      };
      const open = details => {
        this.details.filter(other => other !== details).forEach(other => close(other));
        details.open = true;
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      };
      this.details.forEach(details => {
        const summary = details.querySelector('summary');
        listen(details, 'toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
        listen(details, 'pointerenter', event => {
          cancel(details);
          if (!this.hoverQuery.matches || event.pointerType !== 'mouse' || details.open) return;
          details.openTimer = setTimeout(() => { details.openedByHover = true; open(details); }, 120);
          this.timers.add(details.openTimer);
        });
        listen(details, 'pointerleave', () => {
          cancel(details);
          if (!this.hoverQuery.matches || details.contains(document.activeElement)) return;
          details.closeTimer = setTimeout(() => close(details), 220);
          this.timers.add(details.closeTimer);
        });
        listen(summary, 'click', event => {
          this.details.filter(other => other !== details).forEach(other => close(other));
          if (details.open && details.openedByHover) event.preventDefault();
          details.openedByHover = false;
        });
        listen(details, 'keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            close(details, true);
          } else if (event.target === summary && event.key === 'ArrowDown') {
            event.preventDefault();
            open(details);
            details.querySelector('.doma-nav-panel a')?.focus();
          }
        });
        listen(details, 'focusout', event => {
          clearTimeout(details.focusTimer);
          this.timers.delete(details.focusTimer);
          if (details.contains(event.relatedTarget)) return;
          // Focus can briefly be on body between blur and focus; wait for the next task.
          details.focusTimer = setTimeout(() => {
            this.timers.delete(details.focusTimer);
            if (!details.contains(document.activeElement)) close(details);
          });
          this.timers.add(details.focusTimer);
        });
        listen(details.querySelector('[data-doma-close-menu]'), 'click', () => close(details, true));
      });
      listen(document, 'pointerdown', event => { if (!this.contains(event.target)) this.details.forEach(details => close(details)); });
      listen(window, 'resize', () => { if (!matchMedia('(min-width: 990px)').matches) this.details.forEach(details => close(details)); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.timers?.forEach(timer => clearTimeout(timer));
      this.initialized = false;
    }
  });
}
